import { createContext, useContext, useState } from "react";

const BuyContext = createContext(undefined);

export const BuyProvider = ({children}) => {

    const [token, setToken] = useState("");
    const [product, setProduct] = useState(null);
    const [infoSell, setInfoSell] = useState(null);
  
    const values = {
        token,
        setToken,
        product,
        setProduct,
        infoSell,
        setInfoSell
    };

    return (
        <BuyContext.Provider value={values}>
            {children}
        </BuyContext.Provider>
    );
};

export const useBuy = () => useContext(BuyContext);